/**
 * Budget Allocation Controller
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @return:   Controller
 */

import angular from 'angular';

angular.module('flsControllers').controller('ProgramTopSpeakersController', [
    '$scope',
    'ProgramTopSpeakers',
    function($scope, ProgramTopSpeakers){

    /**
     * Loading state
     *
     * @type {Boolean}
     */
    $scope.loading = false;

    /**
     * Define starting data
     *
     * @type {Object}
     */
    $scope.data = {
        speakers:[],
    }

    /**
     * Init the Controller with the Context Ref string
     *
     * @param  {string} context_ref
     * @return {void}
     */
    $scope.init = function(brand, from = null, to = null) {
        this.load({
            brand: brand || $scope.$parent.brand,
            from : from || $scope.$parent.from,
            to   : to || $scope.$parent.to,
        });
    }

    /**
     * Load the data
     *
     * @param  {object} query
     * @return void
     */
    $scope.load = function(query) {
        /* Enable loader */
        $scope.loading = true;
        /* fetch data */
        ProgramTopSpeakers
            .get(query)
            .$promise
            .then(function(response, headers){
                /* Replace the data*/
                $scope.data = response.data;
                /* Disable loader */
                $scope.loading = false;
            }, function(response, headers){
                _.each(response.data, function(error){
                    $.publish('resource.error', error);
                });
            });
    }

    /**
     * Take n top speakers
     *
     * @return collection
     */
    $scope.topSpeakers = function(n = 20) {
        /* Chain the values */
        return _.chain(this.data.speakers)
                /* order by is two arguments: an array of fields to sort by and array or ORDER BY statements */
                .orderBy(['counts.honoraria'],['desc'])
                .take(n)
                .value();
    }
}]);
